import React, {useEffect, useState} from "react";
import Switch from "react-switch";
import on from "./on.gif";
import off from "./off.gif";
const url = process.env.REACT_APP_SERVER_URL + "/status";
const handleToggle = (setStatus, isToggled,setIsToggled, setMotorLastSeen, setTankLastSeen, setLastOn) => {
    const data = {
        "isManualModeOn": !isToggled
    }
    postData(data, setStatus, setIsToggled, setMotorLastSeen, setTankLastSeen, setLastOn);
    setIsToggled(!isToggled);
};

const handleButtonClick = (status,setStatus, setIsToggled, setMotorLastSeen, setTankLastSeen, setLastOn) => {
    const data = {
        "isMotorOn": !status
    }
    postData(data, setStatus, setIsToggled, setMotorLastSeen, setTankLastSeen, setLastOn);
    setStatus(!status);
};
const postData = (data, setStatus, setIsToggled, setMotorLastSeen, setTankLastSeen, setLastOn) => {
    fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json", // Specify the content type
            "Authorization": localStorage.getItem("Authorization")
        },
        body: JSON.stringify(data)
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json(); // Parse the JSON response
        })
        .then((result) => {
            // {
            //     "isManualModeOn": false,
            //     "isMotorOn": false,
            //     "tankLastSeen": "12:53:07",
            //     "motorLastSeen": "16:41:11",
            //     "lastOn": "12:53:07"
            // }
            setStatus(result[0].isMotorOn);
            setIsToggled(result[0].isManualModeOn);
            setTankLastSeen(result[0].tankLastSeen);
            setMotorLastSeen(result[0].motorLastSeen);
            setLastOn(result[0].lastOn);


        })
        .catch((error) => {
            alert("Wrong Credentials")
        });


}

const getData = (setStatus, setIsToggled, setMotorLastSeen, setTankLastSeen, setLastOn) => {

    fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json", // Specify the content type
            "Authorization": localStorage.getItem("Authorization")
        },
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json(); // Parse the JSON response
        })
        .then((result) => {
            // {
            //     "isManualModeOn": false,
            //     "isMotorOn": false,
            //     "tankLastSeen": "12:53:07",
            //     "motorLastSeen": "16:41:11",
            //     "lastOn": "12:53:07"
            // }
            setStatus(result[0].isMotorOn);
            setIsToggled(result[0].isManualModeOn);
            setTankLastSeen(result[0].tankLastSeen);
            setMotorLastSeen(result[0].motorLastSeen);
            setLastOn(result[0].lastOn);

        })
        .catch((error) => {
            alert("Wrong Credentials")
        });

}
const Dashboard = () => {
    const [isToggled, setIsToggled] = useState(false);
    const [status, setStatus] = useState(false);
    const[motorLastSeen,setMotorLastSeen] = useState("offline");
    const [tankLastSeen, setTankLastSeen] = useState("offline");
    const [lastOn, setLastOn] = useState("0:0:0:0");
    const [time, setTime] = useState(0);
    useEffect(() => {
        // Define the function to run every second
        const intervalId = setInterval(() => {
            getData(setStatus, setIsToggled, setMotorLastSeen, setTankLastSeen, setLastOn);
            setTime(prevTime => prevTime + 2); // Increment time by 1 every second
        }, 1000); // 1000 milliseconds = 1 second

        // Cleanup function to clear the interval when the component unmounts
        return () => clearInterval(intervalId);
    }, []);

    return (<div className="mt-20 w-full text-center">
        {status ? <img className="mx-auto" src={on} alt="on" width="200px"/> : <img className="mx-auto" src={off} width="200px" alt="off"/>}
        <div className="mt-10">
            <label className="block" >
                <Switch onChange={()=>{handleToggle(setStatus, isToggled,setIsToggled, setMotorLastSeen, setTankLastSeen, setLastOn)}} height={20}   checked={isToggled} onColor="#C026D3"/>
                <div className="font-thin">Manual Mode</div>
            </label>
            <div className="mt-10 ">
                <button className={`px-4 py-2 bg-purple-950 text-xl text-white font-thin`} onClick={() => {
                    handleButtonClick(status, setStatus, setIsToggled, setMotorLastSeen, setTankLastSeen, setLastOn)}}>
                    {status ? "On" : "Off"}
                </button>
            </div>

            <div className="justify-between fixed flex w-full bottom-10">
                <div className="block ml-3">Motor
                    <div>{motorLastSeen}</div>
                </div>
                <div className="block ">Last On
                    <div>{lastOn}</div>
                </div>
                <div className="block mr-3">Tank
                    <div>{tankLastSeen}</div>
                </div>

            </div>
        </div>
    </div>)
}
export default Dashboard;